import { SUNRUN_URL } from '@/constants/baseUrls';
import type { ZipDataType } from '@/utils/zipUtility';

export const getZipUtilityFile = async (): Promise<ZipDataType> => {
  const response = await fetch(`${SUNRUN_URL}/utils/zip/zipUtilities.json`);
  return response.json();
};
